// extracted by mini-css-extract-plugin
module.exports = {"badge":"ContingentBadge_badge__O2x89"};